import React from 'react';
import { TableMethodInjectTemplate } from 'themes/components';

function TableMethodInject(props) {
	return <TableMethodInjectTemplate {...props} />;
}

export default TableMethodInject;



// WEBPACK FOOTER //
// ./src/core/components/table/TableMethodInject.jsx